import { BaseNetworkActionHelper } from '../base.network.action.helper';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { PopUpRenderData } from '../../../../networkPopUps/types';

export class AssignTagsActionHelper extends BaseNetworkActionHelper {
  public async processAction(records: Array<ProtectedEntity>): Promise<PopUpRenderData> {
    return {
      isError: false,
      action: Constants.GzTags.Actions.ASSIGN,
    };
  }
}
